// @mui
import Grid from '@mui/material/Unstable_Grid2';

//
import { useResponsive } from 'src/hooks/use-responsive';
import { PostItemSkeleton } from './post-skeleton';
import CategoryItem from './catergory-item';

// ----------------------------------------------------------------------

type Props = {
  categories: any[];
  loading?: boolean;
};

export default function CategoryList({ categories, loading }: Props) {
  const mdUp = useResponsive('up', 'md');
  const renderSkeleton = (
    <>
      {[...Array(16)].map((_, index) => (
        <Grid key={index} xs={12} md={6}>
          <PostItemSkeleton />
        </Grid>
      ))}
    </>
  );

  const renderList = (
    <>
      {categories.map((post) => (
        <Grid key={post._id} xs={6} sm={6} md={6}>
          <CategoryItem post={post} />
        </Grid>
      ))}
    </>
  );

  return (
    <Grid container spacing={mdUp ? 5 : 2} sx={{ mb: mdUp ? 5 : 2 }}>
      {loading ? renderSkeleton : renderList}
    </Grid>
  );
}
